//import { RemoveRedEye as ViewIcon } from '@mui/icons-material';
import { date } from '@/utils/Dates';

export default function Notification({items,handleView}){

    return (
        <div className=''>
        {
            items?.map((notification) => ( 
                notification?.actiu == 1 &&                                               
                <div 
                	key={'notification_'+notification?.id} 
                	className='notification-list-item'
                	onClick = {() => handleView(notification)}
                >
                	<div className='w-full'>
	                    <div className="text-xl font-bold">
	                        {notification?.titulo}
	                    </div>
	                    <div className="text-xs">
	                        {date(notification?.fecha_publicacion,true)}
	                    </div>
	                </div>
	                {/*
                    <div className="modal-buttons">
           	        	<ViewIcon className='action-button-modal text-black' onClick={() => handleView(notification)}/>
                    </div>                    
                    */}
                </div> 
            )) 
        }           
    	</div>
    );
} 